export const stylesRefs = {
  sticky: 'WrapperCell_sticky',
} as const
